import React from 'react';
import "../styles/_footer.scss"
interface Props {}

const Footer: React.FC<Props> = (props) => {
    return (
        <div className="Footer">
        <p > © AL-MARE HOTEL | ALL RIGHTS RESERVED</p>  
            <ul className='d-flex m-0 py-3'>
              <a href="https://www.facebook.com/profile.php?id=100063786630638&ref=br_rs"><li><i className="fab fa-facebook-f"></i> </li></a> 
                <a href=""><li><i className="fab fa-twitter"></i>  </li></a>
                <a href=""><li> <i className="fab fa-linkedin"></i> </li></a>
                <a href=""><li><i className="fab fa-youtube"></i> </li></a>
            </ul>

    </div>

    );
};

export default Footer;